var map = {
	"./archiv-1.jpeg": 9928,
	"./car-1.jpg": 4725,
	"./computers-1.jpg": 9496,
	"./customers-1.jpg": 2737,
	"./developer-1.jpg": 7128,
	"./manuelle-rechnung-1.jpg": 1946,
	"./orders-1.jpg": 2417,
	"./produkte-1.jpg": 136,
	"./service-center-1.jpg": 9813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4509;